export const ActionKeys = Object.freeze({
  SET_DEEP_LINK_PATH: 'SET_DEEP_LINK_PATH',
  SET_SOURCE_PATH: 'SET_SOURCE_PATH',
} as const);

export const DesktopStateKeys = Object.freeze({
  DEEP_LINK_PATH: 'DEEP_LINK_PATH',
  SOURCE_PATH: 'SOURCE_PATH',
} as const);
